import { useState } from 'react';
import { api, ErrorApi, LARGO_MINIMO_CONTRASENA } from '../api';

/**
 * Fijar la contraseña nueva a partir del enlace del correo.
 *
 * Se pide dos veces: el usuario no ve lo que escribe y, si se equivoca, el
 * token ya se consumió y hay que empezar de nuevo. La comparación es local,
 * antes de gastar el enlace.
 */
export function Restablecer({ token, onListo }: { token: string; onListo: () => void }) {
  const [contrasena, setContrasena] = useState('');
  const [repetida, setRepetida] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const [listo, setListo] = useState(false);

  const corta = contrasena.length > 0 && contrasena.length < LARGO_MINIMO_CONTRASENA;
  const noCoinciden = repetida.length > 0 && contrasena !== repetida;

  async function enviar(evento: React.FormEvent): Promise<void> {
    evento.preventDefault();
    if (corta || noCoinciden || !contrasena) return;

    setEnviando(true);
    setError(null);
    try {
      await api.restablecer(token, contrasena);
      setListo(true);
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'no se pudo contactar el portal');
    } finally {
      setEnviando(false);
    }
  }

  if (listo) {
    return (
      <div className="acceso">
        <h1>Contraseña actualizada</h1>
        <p>
          Se cerraron todas las sesiones abiertas de tu cuenta. Entra de nuevo con la contraseña
          nueva.
        </p>
        <button onClick={onListo}>Ir al acceso</button>
      </div>
    );
  }

  return (
    <div className="acceso">
      <h1>Elige una contraseña nueva</h1>
      <p>Mínimo {LARGO_MINIMO_CONTRASENA} caracteres.</p>

      <form onSubmit={(e) => void enviar(e)}>
        <label>
          <span>Contraseña nueva</span>
          <input
            type="password"
            value={contrasena}
            onChange={(e) => setContrasena(e.target.value)}
            autoComplete="new-password"
            autoFocus
            required
          />
        </label>

        <label>
          <span>Repítela</span>
          <input
            type="password"
            value={repetida}
            onChange={(e) => setRepetida(e.target.value)}
            autoComplete="new-password"
            required
          />
        </label>

        {corta && <p className="aviso-campo">Te faltan {LARGO_MINIMO_CONTRASENA - contrasena.length} caracteres.</p>}
        {noCoinciden && <p className="aviso-campo">Las dos contraseñas no coinciden.</p>}

        <button type="submit" disabled={enviando || corta || noCoinciden || !contrasena}>
          {enviando ? 'Guardando…' : 'Guardar contraseña'}
        </button>
      </form>

      {error && <p className="error">{error}</p>}

      <button className="enlace bajo" onClick={onListo}>
        Volver al acceso
      </button>
    </div>
  );
}
